import React from "react";
import { Container, Row, Col } from "reactstrap";
import Card from "reactstrap/lib/Card";

function TextGrid() {
  let pageHeader = React.createRef();
  const size =
    document.body.clientWidth >= 1024 || document.documentElement.clientWidth >= 1024
      ? true
      : false;
  return (
    <>
      <div
        style={{
          backgroundColor: "#fff",
          background: `url(${require("assets/images/photo-1566734904496-9309bb1798ae.jpeg")})`,
          backgroundRepeat: "no-repeat",
          backgroundAttachment: "fixed",
          backgroundPosition: "center",
          backgroundSize: "cover",
          paddingTop: "8rem",
          overflow: "hidden",
        }}
        className="section py-3"
        data-parallax={true}
        ref={pageHeader}
      >
        <div className="overlay-primary"></div>
        <Container>
          <Row className="justify-content-center">
            <Col md={6} className={size ? "border-right" : "border-bottom"}>
              <h1
                className="m-0 my-4 text-g text-white"
                style={{
                  fontSize: size ? "3rem" : "2rem",
                }}
              >
                Event
                <br />
                Summary
              </h1>
              <p className="text-400 text-white">
                <span className="text-700 text-i">Aotearoa New Zealand </span> is in the middle of a
                once-in-a-generation reshape of its cities, water networks and energy systems – from
                housing and planning reforms to Local Water Done Well, smart grids and world-class
                digital fibre. Utilities and councils are already using digital twins and AI to
                modernise water treatment plants, untangle legacy asset data and move from reactive
                repair to predictive maintenance, while pilots in wastewater, flooding and smart
                irrigation are showing how virtual replicas of networks can sharpen investment and
                resilience decisions. At the same time, New Zealand’s fibre network and data
                infrastructure are enabling new “weightless” digital exports and AI-enabled services
                that depend on high-quality, real-time information about the physical world.
                <br />
                <br />
                Against this backdrop, the{" "}
                <span className="text-700 text-i">NZ Digital Twin 2026</span> returns to Aotearoa on
                May 7 for the Confex and May 8 for the Workshops, to bring together infrastructure
                owners, urban planners, utilities, Māori and community leaders, technologists and
                researchers from across Australia and New Zealand. The program will explore how
                digital twins, AI and advanced data infrastructure can support compact,
                transit-oriented urban growth; integrated housing and infrastructure planning;
                climate-resilient water and wastewater services; clean-energy and smart-grid
                transitions; and evidence-driven spatial planning under New Zealand’s evolving
                resource management and planning framework, alongside emerging trans-Tasman climate
                and digital innovation partnerships.
                <br />
                <br />
                Delegates can expect in-depth case studies from major projects such as Auckland’s
                City Rail Link – New Zealand’s largest transport infrastructure project and its
                first urban underground rail system – alongside council-scale digital twins,
                electricity distribution and smart-metering programs, and next-generation urban
                water initiatives. With a mix of keynote sessions, technical talks, interactive
                panels and a focused exhibition, the conference is designed to accelerate a dynamic,
                standards-aligned and investable digital twin ecosystem across the ANZ region. Join
                us in New Zealand to connect, collaborate and turn digital twin ambition into
                tangible outcomes for communities, climate and the economy.
                <br />
                <br />
              </p>
            </Col>
            <Col md={6} className="pr-0">
              <h1
                className="m-0 my-4 text-g"
                style={{
                  fontSize: size ? "3rem" : "2rem",
                }}
              >
                Conference
                <br />
                Format
              </h1>

              <div className="container-fluid row justify-content-center">
                {content.map((c, i) => (
                  <Col xs={12}>
                    <Card
                      style={{
                        background: c.color,
                        minHeight: size ? "80px" : "none",
                        maxWidth: "400px",
                      }}
                    >
                      <div className="d-flex p-2  ">
                        <div className="px-2 align-self-center" style={{ maxWidth: "70px" }}>
                          <img
                            src={require(`assets/icons/${c.image}`)}
                            // style={{ width: "70px" }}
                            width="100%"
                            alt="about"
                            className=""
                          />
                        </div>
                        <p className="text-400 py-2 pl-3 text-white align-self-center">{c.title}</p>
                      </div>
                    </Card>
                  </Col>
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default TextGrid;

const content = [
  {
    title: "VIP KEYNOTE SPEECHES",
    image: "14.png",
    color: "#6bbac2",
  },
  {
    title: "PROJECT CASE STUDIES AND PROOF OF CONCEPTS",
    image: "12.png",
    color: "#bfbe28",
  },
  {
    title: "THOUGHT-PROVOKING PANEL DISCUSSIONS",
    image: "42.png",
    color: "#6bbac2",
  },
  {
    title: "ROUND TABLE SESSIONS",
    image: "Asset 7.png",
    color: "#bfbe28",
  },
  {
    title: "TECHNICAL WORKSHOPS",
    image: "41.png",
    color: "#6bbac2",
  },
  {
    title: "EXHIBITION & NETWORKING ",
    image: "43.png",
    color: "#bfbe28",
  },
];
